import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ViewerDocumentService {

    private _isDocumentLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    set loadingDocument(loading: boolean) {
        if (this._isDocumentLoading.getValue() === loading) {
            return;
        }

        this._isDocumentLoading.next(loading);
    }

    get loadingDocument(): boolean {
        return this._isDocumentLoading.getValue();
    }

    get isLoadingDocument(): Observable<boolean> {
        return this._isDocumentLoading.asObservable();
    }
}
